__turbopack_context__.v({
  "container": "login-module__yuVLNW__container",
  "fadeInItems": "login-module__yuVLNW__fadeInItems",
  "spacing--lg": "login-module__yuVLNW__spacing--lg",
  "spacing--md": "login-module__yuVLNW__spacing--md",
  "spacing--sm": "login-module__yuVLNW__spacing--sm",
  "spacing--xl": "login-module__yuVLNW__spacing--xl",
  "spacing--xs": "login-module__yuVLNW__spacing--xs",
  "spacing--xxl": "login-module__yuVLNW__spacing--xxl",
  "spacing--xxs": "login-module__yuVLNW__spacing--xxs",
  "spacing--xxxl": "login-module__yuVLNW__spacing--xxxl",
  "spacing--xxxs": "login-module__yuVLNW__spacing--xxxs",
});
